import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Env } from '../env';
import { BankListItem } from '../models/bankListItem';
import { Observable } from 'rxjs';
import { Bank } from '../models/bank';
import { environment } from '../../environments/environment';
import { AngularFireStorage } from 'angularfire2/storage';
import { finalize } from 'rxjs/operators';
import { BankListItemSource } from '../models/bankListItemSource';
import { BankSource } from '../models/bankSource';

@Injectable()
export class BankService {

  constructor( 
    private http: HttpClient, 
    private global: Env,
    private storage: AngularFireStorage, 
  ) { }

  getAll(): Observable<BankListItemSource[]> {
    const url = this.global.bank;
    return this.http.get(url).map( (res:BankListItemSource[]) => {
      return res;
    });
  }

  get( id ): Observable<BankSource> {
    const url = this.global.bank + '/' + id;
    return this.http.get(url).map( (res:BankSource) => {
      return res;
    });
  }

  updateBank( logo:String , name:String , id ){
    const url = this.global.bank + '/' + id;
    return this.http.post(url , {  logo: logo, name: name  }).map( (res:BankListItem) => {
      return res;
    });
  }

  uploadBankLogo( files:File , name ){
      let blobName = "bank-"+name;
      let extensionName = files.name.split('.').pop();
      let filePath = `${environment.env}/${this.global.FOLDER_IMAGES['Bank']}/${blobName}.${extensionName}`;
      //console.log(filePath);
      
      
      let ref = this.storage.ref(filePath);
      //console.log(fileRef);
      
      
      let task = this.storage.upload(filePath, files);
      //ref.getDownloadURL( r => {console.log(r);} );
      return task.snapshotChanges().pipe(
        finalize(() => {
          let downloadURL = ref.getDownloadURL()
          downloadURL.subscribe( url => { 
            //console.log( url );
          });
        })
      )
  }

  createBank( logo:String , name:String  ){
    const url = this.global.bank;
    console.log(url);
    console.log({  logo: logo, name: name  });
    return this.http.post(url , {  logo: logo, name: name  }).map( (res:BankListItem) => {
      return res;
    });
  }

  removeBank( id ){
    const url = this.global.bank + '/' + id;
    return this.http.delete( url ).map( (res:BankListItem) => {
      return res;
    });
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/services/bank.service.ts